export interface twoFAresponse {
    "success": boolean,
    reason: "WRONG_CREDENTIALS" | "CANT_REACH" | "SERVER_ERROR" | "BAD_REQUEST" | undefined
    response? : any
}

export type frontendRoleType = "assistant" | "authenticated" | "authenticated_professional" | "administrator" | "groupmanager"
export const frontendRoles : frontendRoleType[] = ['assistant', 'authenticated', 'authenticated_professional', 'administrator', 'groupmanager'];

export type allDateTypes = "dateBefore" | "dateAfter" | "dateAny"
export const allExistingDateTypes : allDateTypes[] = ["dateBefore" , "dateAfter" , "dateAny"]

type entryPropBase = {
    name: string,
    label: string,
    type: allInputDataTypes,
    //TODO: reduce variations here to a minimum
    //options?: frontendRoleType[] | Object | { [key: number]: string; } | Array<{value: number|string, label: number|string}> ,
    default?: string | number | boolean,
    disabled?: boolean,
    minLength?: number,
    maxLength?: number,
    required: boolean,
    helpMessage: string,
    value?: any
    visible?: boolean // if a field should sometimes be shown or sometimes not
    private?: boolean // if something should always be hidden or not, prevalently used in "edit" components.
    skipValidation?: boolean // if a field should not be validated, e.g. because the backend does not validate it
    unique?: boolean // if a field is unique in the backend, e.g. username, email, matricule
    
    statusIconOn?: ('valid' | 'invalid' | 'pending')[];
    invalidWhen?: 'touched' | 'dirty' | 'always' | 'touchedOrDirty';
}

export type entryProp = entryPropBase & ( // either type is options and the options are defined, or none of it is.
    | {type: Exclude<allInputDataTypes, "options">, options?: never}
    | {type: "options"; options: { [key: number]: string; } | Array<{value: number|string, label: number|string}>} // a bit unsure why these array-based options work, but...
    | {type: "keyValueOptions"; options: { [key: string | number]: string; }} // ... let's create the keyValue options as well
)

export type allInputDataTypes = "string" | "email" | "password" | "options" | "keyValueOptions" | "text" | "date" | allDateTypes | "number" | "boolean" | "matricule"; // leaving "date" to support datatypes like index etc. where the date handling has not been updated yet to dateBefore etc.

export type indexDataField = Omit<entryProp, 'type'> & {
    type: "string" | "email" | "password" | "options" | "text" | "date" | allDateTypes | "number" | "boolean" | "nomenclatureID" | "nomenclatureDescription"
}

export type definedIndexDataField = indexDataField & {
    value: any
}

export type calculatedDataField = entryProp & {
    value: any
}

export interface searchQueryOptions {
    _contains?: string,
}
 
export interface ContextMenuModel {
    menuText: string;
    menuEvent: string;
    menuIcon?: string;
}

export type availableLanguages = 'en' | 'de' | 'fr'

export interface IstrapiRole {
    "id": number,
    "name": string,
    "description": string,
    "type": string,
    "createdAt": string,
    "updatedAt": string,
    "nb_users": number
}

export interface strapiMeta {
    "pagination": {
        "page": number,
        "pageSize": number,
        "pageCount": number,
        "total": number
    }
}

export type availableDevices = Array<Device>
export type deviceType = "printer"

export interface Device {
 type: deviceType
 id: string
 name: string
 status: "online" | "offline" | "error"
}

// create an enum for 3 different subscription statuses
export enum subscriptionStatus {
    "ACTIVE" = "ACTIVE",
    "EXPIRED" = "EXPIRED"
}

// request parameter options for findRelatedUsers

export interface SearchRelatedUserOptions {
    ignoreLimit?: boolean,
    // an array of principals we're only interested in instead of searching through all the allowed principals 
    principals?: number[]
}